import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/amenitiesPage/AmenitiesPageComponent.tsx");
